import { service } from './index';
import LabelLayerTree from '@/presentation/components/LabelLayerTree/LabelLayerTree.vue';
import _ from 'lodash';
import { Icon as PzIcon } from 'patsnap-biz';
export const name = 'LAYER.render';
const MAX_VISIBLE_NODES = 10;
const forEachTree = (nodes, cb) => {
    nodes.forEach((node) => {
        if (!cb(node))
            return false;
        if (node.children) {
            forEachTree(node.children, cb);
        }
    });
};
function filterTree(nodes, values) {
    const family = [];
    const visibleMap = {};
    const result = [];
    function markVisibleNodes(nodes) {
        nodes.forEach(node => {
            family.push(node);
            if (values.indexOf(node.id) > -1) {
                family.forEach((parent) => {
                    visibleMap[parent.id] = true;
                });
            }
            const children = node.children;
            if (children) {
                markVisibleNodes(children);
            }
            family.pop();
        });
    }
    markVisibleNodes(nodes);
    forEachTree(nodes, ({ id, name, level, children }) => {
        if (visibleMap[id]) {
            let isLeaf = true;
            if (children && children.length) {
                isLeaf = !_.some(children, ({ id }) => visibleMap[id]);
            }
            result.push({ id, name, level, isLeaf });
            return true;
        }
        return false;
    });
    return result;
}
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { _column } = renderOpts;
    const { row, column } = params;
    const attrs = service.getRenderAttrs(row, column, name);
    service.getCustomFieldIdNameMapping(column.property, _column._props);
    const treeData = _column._props.field_layer_value || [];
    const cellValue = row[column.property] || [];
    let tree = null;
    if (cellValue && cellValue.length) {
        const treeList = (filterTree(treeData, cellValue) || []).slice(0, MAX_VISIBLE_NODES);
        tree = _.map(treeList, ({ id, level, name, isLeaf }) => {
            return <div style={`padding-left: ${(level - 1) * 12}px;`} data-node-id={id}>
                {isLeaf ? <div class="leaf-node"></div> : <PzIcon icon="SolidDropdownOpen" style={{ fill: '#555', fontSize: '20px' }}/>}
                {name}
            </div>;
        });
    }
    return [
        // @ts-ignore
        <div class="xtable-cell-render" attrs={attrs}>
            {tree}
        </div>,
    ];
}
// 可编辑激活模板
function renderEdit(h, renderOpts, params) {
    const { _column } = renderOpts;
    const { row, column } = params;
    const attrs = service.getRenderAttrs(row, column, name);
    const editor = (
    // @ts-ignore
    <div class="xtable-cell-editor" attrs={attrs}>
            <LabelLayerTree supportFilter tree-data={_.get(_column, '_props.field_layer_value') || []} state-cache-key={column.property} value={row[column.property] || []} onChange={data => service.updateCellValue(row, column, data)}/>
        </div>);
    this.$nextTick(() => {
        service.updateEditorRect(editor, row, column);
    });
    return [editor];
}
// 可编辑显示模板
const renderCell = renderDefault;
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const idNameMapping = service.getCustomFieldIdNameMapping(column.property);
    const result = _.map(row[column.property] || [], id => {
        return idNameMapping[id];
    });
    return result.join(',');
}
export default {
    renderDefault,
    renderEdit,
    renderCell,
    exportMethod,
};
